<template>
  <v-dialog
    v-model="opened"
    persistent
    max-width="310"
    light
  >
    <v-card>
      <v-card-title class="headline">
        Renommer dossier
      </v-card-title>

      <v-divider />

      <v-card-text class="pt-4">
        <v-form
          ref="form"
          v-model="validForm"
          lazy-validation
          @submit.prevent=""
        >
          <v-text-field
            v-model="folderName"
            label="Folder Name *"
            required
            placeholder="Folder Name"
            color="info"
            :rules="[rules.required]"
          />
        </v-form>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn
          color="success"
          small
          @click="renameFolder"
        >
          Rename
        </v-btn>
        <v-btn
          color="info"
          small
          @click="closeOnClickOutside"
        >
          Annuler
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref, reactive } from 'vue';
import { useMutation } from '@vue/apollo-composable';

import { useStore } from 'vue2-helpers/vuex';
import { getGraphqlSchema } from '../../graphql/index';
import { EventBus } from '../../mixins';

const item = ref(null);

const opened = ref(null);

const creating = ref(false);

const validForm = ref(false);

const folderName = ref('');

const form = ref(null);

const rules = reactive({ required: v => !!v || 'Required' });

const open = newItem => {
  opened.value = true;

  // Clears the folder name input field
  // this.$refs.form.resetValidation() OR this.folderName = '' OR nextTick()

  // Set's the directory where the folder will be created
  item.value = newItem;

  folderName.value = item.value.wtitle;
};

// eslint-disable-next-line no-undef
defineExpose({ open });

const close = () => {
  if (opened.value) {
    document.documentElement.style.overflow = 'auto';
    opened.value = false;
  }
};

const closeOnClickOutside = () => {
  if (opened.value) {
    document.documentElement.style.overflow = 'auto';
    opened.value = false;
  }
};

const store = useStore();

const { mutate: renameDir, onDone, onError } = useMutation(getGraphqlSchema('renameFolder'), () => ({
  variables: {
    uuid: item.value.uuid,
    folderName: folderName.value
  }
}));

onDone(result => {
  const options = {
    closeable: true,
    timeout: 5000,
    type: 'success'
  };

  let text = `Folder renamed to "${folderName.value}"!`;

  // Error on rename the Folder
  if (!result.data.renameDir.success) {
    options.type = 'error';
    text = result.data.renameDir.message;
  } else {
    const newItem = item.value;
    newItem.name = folderName.value;
    newItem.wtitle = folderName.value;

    EventBus.$emit('replaceItem', { oldItemId: item.value.uuid, newItem: newItem });
  }

  creating.value = false;
  // Send a notification event
  EventBus.$emit('show-notification', { text, options });

  close();
});

onError(error => {
  creating.value = false;

  const options = {
    closeable: true,
    timeout: 4000,
    type: 'error'
  };

  const text = error.message;

  EventBus.$emit('show-notification', { text, options });

  close();
});

const renameFolder = () => {
  if (form.value.validate()) {
    creating.value = true;

    const options = {
      timeout: 5000,
      type: 'info'
    };

    const text = `Renaming folder "${item.value.wtitle}" to "${folderName.value}"`;

    EventBus.$emit('show-notification', { text, options });
    renameDir();
  }
};

</script>

<style lang="scss">

    .v-card__actions {
        height: 50px;
    }

</style>
